import React from 'react'

const Policy = () => {
    return (
        <p>Policy</p>
    )
}

export default Policy;
